import styles from './styles.module.scss';
import { FC } from 'react';

export const RegNo: FC<{ regNo?: string | null }> = ({ regNo }) => {
  return <span className={styles.container}>{regNo ?? '-'}</span>;
};
